"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OUT_OF_RANGE = exports.MSG_REQUIRED = void 0;
var MSG_REQUIRED = "Campo requerido";
exports.MSG_REQUIRED = MSG_REQUIRED;
var OUT_OF_RANGE = "Valor fuera de rango";
exports.OUT_OF_RANGE = OUT_OF_RANGE;